import axios from 'axios'
// import store from './store'
// import qs from 'querystring'
const serverIp = 'livelearning.liveabc.com'
const appPath = '/RealChallengeAPI/api'
const protocal = 'https'
export const apiPath = protocal + '://' + serverIp + appPath
const ersUrl = 'https://voicerecognition.liveabc.com/api/ERS'

function getParamByName (name, url) {
  if (!url) {
    url = window.location.href
  }
  // name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  var results = regex.exec(url)
  if (!results) {
    return null
  }

  if (!results[2]) {
    return ''
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export const redirect = getParamByName('redirect')
export const token = getParamByName('token')
window.localStorage.setItem('token', token)
const api = axios.create({
  baseURL: apiPath,
  timeout: 60000,
  headers: {
    'Authorization': 'bearer ' + window.localStorage.getItem('token')
  }
})

// Authorization
api.interceptors.request.use(function (config) {
  // store.commit('isLoading', true)
  return config
}, function (error) {
  return Promise.reject(error)
})

api.interceptors.response.use(function (response) {
  // store.commit('isLoading', false)
  return response
}, function (error) {
  // store.commit('isLoading', false)

  if (error.response && (error.response.status >= 400 && error.response.status < 500)) {
    // window.location = window.location.pathname
    // window.top.location.href = protocal + '://' + serverIp
    // store.commit('setErrorMessage', '已登出，請重新登入')
  } else if (error.response.data) {
    var msg = error.response.data.Message || error.response.data.error_description
    if (msg === '') {
      msg = '未知錯誤'
    }
    // store.commit('setErrorMessage', msg)
  } else {
    // store.commit('setErrorMessage', error.message)
  }
  return Promise.reject(error)
})

export default {
  // Lesson: {
  //   Item: (lessonId) => {
  //     return api.get('/Lesson/' + lessonId)
  //   },

  //   List: (config) => {
  //     var pageIndex = config.pageIndex || 1
  //     var pageSize = config.pageSize || 20
  //     var level = config.level || ''
  //     var category = config.category || ''

  //     return api.get('/Lesson?pageIndex=' + pageIndex + '&pageSize=' + pageSize + '&level=' + level + '&categoryId=' + category)
  //   },

  //   Module: (moduleId) => {
  //     return api.get('/LessonModule/' + moduleId)
  //   },

  //   Practice: (lessonId) => {
  //     return api.get('/Lesson/' + lessonId + '/Practices')
  //   },

  //   ErsData: (moduleId) => {
  //     return api.get('/LessonModule/' + moduleId + '/Sentences/ERS')
  //   },

  //   Record: {
  //     Time: (lessonId, type) => {
  //       // type: add, update
  //       return api.post('/Lesson/' + lessonId + '/Record/' + type)
  //     },

  //     Practice: (lessonId, score) => {
  //       var formData = new window.FormData()
  //       formData.append('score', score)

  //       return api.post('/Lesson/' + lessonId + '/Record/Practices', formData)
  //     },

  //     Ers: (moduleId, no, data) => {
  //       return api.post('/LessonModule/' + moduleId + '/Sentences/' + no + '/ERS', data)
  //     }
  //   }
  // },

  Ers: {
    Upload: (text, blob) => {
      return axios.post(ersUrl + '?stext=' + encodeURI(text), blob)
    },

    Result: (id) => {
      return axios.get(ersUrl + '/' + id)
    }
  },

  Dictionary: {
    Word: (word) => {
      return api.get('/Dic/' + word)
    },

    Speak: (word) => {
      var audio = new window.Audio(apiPath + '/Dic/' + word + '/Audio')
      audio.play()
    }
  },

  Exam: {
    Start: (examPaperId) => {
      return api.get('/Exam/' + examPaperId + '/Start')
    },

    Answer: (recordId, answers) => {
      return api.post('/Exam/' + recordId + '/Answer', answers)
    },

    Finish: (recordId) => {
      return api.post('/Exam/' + recordId + '/Finish')
    }
  },

  Question: {
    send: (lessonId, sents, content) => {
      sents = sents || []
      content = content || ''

      return api.post('/Lesson/' + lessonId + '/MyQuestion', {
        sentences: sents,
        content: content
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/live-player/api.js